import styled from 'styled-components';

export default styled.div`
  background: url(${(props) => props.imgUrl}) no-repeat;
  flex-shrink: 0;
  width: 100%;
  height: 240px;
  background-size: cover;
  background-position: center;
  @media (max-width: 600px) {
    height: 160px;
  }
`;
